/**
 * Supsis Web Analytics - yalnizca tracking entegrasyonu (tracker.js).
 *
 * Web chat kullanmayan musteriler icin: chat balonu, iframe ve supsis-actions yuklenmez;
 * yalnizca web analytics tracker'i ve SDK'nin analytics komutlari
 * (track / identify / ecommerce / consent ...) calisir.
 *
 * Kurulum:
 *   <script>window.supsis=window.supsis||function(){(supsis.q=supsis.q||[]).push(arguments)};supsis.l=+new Date();</script>
 *   <script src="https://<site-adresi>/static/js/tracker.js" async defer></script>
 *
 * Bu script loader.js ile BIRLIKTE kullanilmaz: loader.js zaten tracker'i iceriyor.
 * Ikisi de sayfadaysa ikinci yuklenen calismaz ve konsola uyari yazar.
 */
require("./src/sdk");
import { isInitializedBefore } from "./src/sdk";
import log2 from "./js/log2-lite";
import { fetchSiteData, fetchSiteSetting } from "./src/utils";
import { initWebAnalytics } from "./src/analyticsBoot";

const log = log2("TrackerLoader");

function start() {
    // loader.js ile ayni bayrak: hangisi once yuklenirse digeri devre disi kalir
    window.supsisLoadingStarted = true;
    window.supsisTrackerOnly = true;

    fetchSiteData().then((site) => {
        if (!site || !site._id) {
            log.warn("site not found for this address; tracker not started");
            return;
        }
        window.siteData = site;
        fetchSiteSetting(site._id).then((settings) => {
            const siteSettings = Array.isArray(settings) ? settings[0] : settings;
            const started = initWebAnalytics(site, siteSettings);
            log.info(started ? "tracker-only mode started" : "tracker-only mode: analytics not enabled for site");
        });
    });
}

if (isInitializedBefore || window.supsisLoadingStarted === true) {
    log.error("SUPSIS is initialized before. tracker.js and loader.js must not be used together; keep only loader.js");
} else {
    start();
}



//////////////////
// WEBPACK FOOTER
// ./static/tracker.js
// module id = 85Vk
// module chunks = 2